import React from 'react'
import { CompanyRouteImport } from './Import'
const { RoutesMap, AddCompany, CompanyList, UpdateCompany, AddCompanyUser, CompanyUserList, UpdateCompanyUser, ItAdminList, AddItAdmin, UpdateItAdmin, ItAdminDetails, VendorList, AddVendor, UpdateVendor, VendorDetails, VendorEmployeeList, AddVendorEmployee, UpdateVendorEmployee, VendorEmployeeDetails, InstituteOnboardingList, AddInstituteOnboarding, UpdateInstituteOnboarding, InstituteOnboardingDetails, BranchOfficeList, AddBranchOffice, UpdateBranchOffice, BranchOfficeDetails, BranchCourseList, AddBranchCourse, UpdateBranchCourse } = CompanyRouteImport

const CompanyRoute = () => {
    return [
        {
            path: RoutesMap.ADD_COMPANY.path,
            element: <AddCompany />
        },
        {
            path: RoutesMap.UPDATE_COMPANY.path,
            element: <UpdateCompany />
        },
        {
            path: RoutesMap.COMPANY_LIST.path,
            element: <CompanyList />
        },

        {
            path: RoutesMap.ADD_COMPANY_USER.path,
            element: <AddCompanyUser />
        },
        {
            path: RoutesMap.UPDATE_COMPANY_USER.path,
            element: <UpdateCompanyUser />
        },
        {
            path: RoutesMap.COMPANY_USER_LIST.path,
            element: <CompanyUserList />
        },

        {
            path: RoutesMap.ADD_IT_ADMIN.path,
            element: <AddItAdmin />
        },
        {
            path: RoutesMap.UPDATE_IT_ADMIN.path,
            element: <UpdateItAdmin />
        },
        {
            path: RoutesMap.IT_ADMIN_LIST.path,
            element: <ItAdminList />
        },
        {
            path: RoutesMap.IT_ADMIN_DETAILS.path,
            element: <ItAdminDetails />
        },

        {
            path: RoutesMap.ADD_VENDOR.path,
            element: <AddVendor />
        },
        {
            path: RoutesMap.UPDATE_VENDOR.path,
            element: <UpdateVendor />
        },
        {
            path: RoutesMap.VENDOR_LIST.path,
            element: <VendorList />
        },
        {
            path: RoutesMap.VENDOR_DETAILS.path,
            element: <VendorDetails />
        },

        {
            path: RoutesMap.ADD_VENDOR_EMPLOYEE.path,
            element: <AddVendorEmployee />
        },
        {
            path: RoutesMap.UPDATE_VENDOR_EMPLOYEE.path,
            element: <UpdateVendorEmployee />
        },
        {
            path: RoutesMap.VENDOR_EMPLOYEE_LIST.path,
            element: <VendorEmployeeList />
        },
        {
            path: RoutesMap.VENDOR_EMPLOYEE_DETAILS.path,
            element: <VendorEmployeeDetails />
        },

        {
            path: RoutesMap.ADD_INSTITUTE_ONBOARDING.path,
            element: <AddInstituteOnboarding />
        },
        {
            path: RoutesMap.UPDATE_INSTITUTE_ONBOARDING.path,
            element: <UpdateInstituteOnboarding />
        },
        {
            path: RoutesMap.INSTITUTE_ONBOARDING_LIST.path,
            element: <InstituteOnboardingList />
        },
        {
            path: RoutesMap.INSTITUTE_ONBOARDING_DETAILS.path,
            element: <InstituteOnboardingDetails />
        },

        {
            path: RoutesMap.ADD_BRANCH_OFFICE.path,
            element: <AddBranchOffice />
        },
        {
            path: RoutesMap.UPDATE_BRANCH_OFFICE.path,
            element: <UpdateBranchOffice />
        },
        {
            path: RoutesMap.BRANCH_OFFICE_LIST.path,
            element: <BranchOfficeList />
        },
        {
            path: RoutesMap.BRANCH_OFFICE_DETAILS.path,
            element: <BranchOfficeDetails />
        },

        {
            path: RoutesMap.BRANCH_COURSE_LIST.path,
            element: <BranchCourseList />
        },
        {
            path: RoutesMap.ADD_BRANCH_COURSE.path,
            element: <AddBranchCourse />
        },
        {
            path: RoutesMap.UPDATE_BRANCH_COURSE.path,
            element: <UpdateBranchCourse />
        },
    ]
}

export default CompanyRoute;
